<template>
    <div class="detail-other-info">
        <div v-for="(block, index) in baseData" :key="index">
            <div v-if="block && block.name === 'activity'" class="activity-ctn">
                <coupon :couponList="block.couponList" v-if="block.couponList && block.couponList.length" @openPackagePopup="openPackagePopup"></coupon>
                <discount :psList="block.psList" :promotionFlagList="block.promotionFlagList" v-if="block.psList && block.psList.length"></discount>
            </div>
            <depart-city v-if="block && block.name === 'departCity'"></depart-city>
            <calendar v-if="block && block.name === 'priceCalendar' && block.calendarList" 
                :timeDifference="timeDifference" 
                :isSecondSure="head && head.isSecondSure" 
                :passRate="head && head.passRate" 
                :confirmDuration="head && head.confirmDuration" 
                :packageData="packageData"
                :prdTmpId="prdTmpId"
            ></calendar>
            <package v-else-if="block && block.name === 'priceCalendar' && packageNum && packageNum > 1" @openPackagePopup="openPackagePopup"></package>
            <remark v-if="block && block.name === 'remark' && block.hasOwnProperty('remarkCount')" :baseData="block"></remark>
           <shop-brief :agencyType="agencyType" :prdTmpId="prdTmpId" :shopData="block" :isApp="isApp" v-if="block && block.name === 'shop' && !isHideShop"></shop-brief>
        </div>
        
    </div>
</template>

<script>
import TouchStrip from '@/components/TouchStrip';
import Calendar from '@/components/detail/Calendar';
import Discount from '@/components/detail/Discount';
import Coupon from '@/components/detail/Coupon';
import DepartCity from '@/components/detail/DepartCity';
import Package from '@/components/detail/Package';
import Remark from '@/components/detail/Remark';
import ShopBrief from '@/components/detail/ShopBrief';
import {eventTrack} from '@/business/analy';


export default {
    name: 'otherInfo',
    data() {
        return {
        }
    },
    props: {
        baseData: {
            type: Array,
            default: function () {
                return []
            }
        },
        isApp: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        prdTmpId: {
            type: Number,
            default: function () {
                return 5
            }
        },
        packageNum: {
            type: Number,
            default: function () {
                return 1
            }
        },
        timeDifference: {
            type: Boolean,
             default: function () {
                return false
            }
        },
        head: {
            type: Object,
             default: function () {
                return {}
            }
        },
        packageData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        agencyType: {
            type: Number,
            default: function () {
                return 1
            }
        },
        isHideShop:{
           type: Boolean,
             default: function () {
                return false
            } 
        }
    },

    methods: {
        openDiscount() {
            this.$router.push(this.$route.path + '/discount');
        },
        openCoupon() {
            this.$router.push(this.$route.path + '/coupon');
        },
        openPackagePopup() {
            this.$emit('openPackagePopup');
        },
        eventTrack
    },
    components: {
        Calendar,
        TouchStrip,
        Discount,
        Coupon,
        DepartCity,
        Package,
        Remark,
        ShopBrief
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';
.detail-other-info {
    
    //优惠信息
    .activity-ctn {
        overflow: hidden;
        border-radius: $borderBigRadius;
        margin: 9px 0;
        width: 100%;
        &:empty {
            margin: 0;
        }
        .promotion-strip {
            margin: 0;
        }
        .promotion-strip ~ .promotion-strip:before {
            content: '';
            position: absolute;
            top: 0;
            left: 18px;
            right: 18px;
            height: 1px;
            background: linear-gradient(top, rgba(0, 0, 0, 0.05), transparent 50%, transparent);
        }
    }
}
</style>



// WEBPACK FOOTER //
// OtherInfo.vue